export default __webpack_public_path__ + "static/media/LogoWhite.7943825e.png";